<template>
    <ModalComponent
        name="avisos-plazos"
        :title="sonAbonos ? 'Enviar avisos para dar de baja los abonos con plazos fallidos' : 'Enviar avisos de plazos impagados fallidos definitivos'"
        v-on:close="close"
    >
        <ContentAvisos @terminar="terminar" :loading="loading" @close="close" :sonAbonos="sonAbonos"/>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import ContentAvisos from "./components/ContentAvisos";

    export default {
        props: ['sonAbonos', 'loading'],
        methods: {
            close() {
                this.$emit('close', 'avisos-plazos');
            },
            terminar() {
                this.$emit('terminado');
            }
        },
        components: {
            ModalComponent, ContentAvisos
        }
    }
</script>
